// components/LocationDetails.js
import React from "react";

const LocationDetails = ({ data }) => {
  if (!data) return null;

  return (
    <div style={{ marginTop: "20px", background: "#f9f9f9", padding: "15px", borderRadius: "8px" }}>
      <h4>📍 Data Lokasi:</h4>
      <p><strong>Nama Tempat:</strong> {data.name}</p>
      <p><strong>Alamat:</strong> {data.address}</p>
      <p><strong>Latitude:</strong> {data.latitude}</p>
      <p><strong>Longitude:</strong> {data.longitude}</p>
      <p><strong>Negara:</strong> {data.negara}</p>
      <p><strong>Provinsi:</strong> {data.province}</p>
      <p><strong>Kota / Kabupaten:</strong> {data.city}</p>
      <p><strong>Kecamatan:</strong> {data.kecamatan}</p>
    </div>
  );
};

export default LocationDetails;
